"use client"
import { Link } from "react-router-dom"
import { useTranslations } from "../translations"

const Terms = () => {
  const { t } = useTranslations()

  return (
    <div className="privacy-page-container">
      <div className="privacy-card">
        <div className="privacy-header">
          <Link to="/" className="btn-back">
            &larr; {t("back")}
          </Link>
          <img src="/assets/img/landing-images/MiABC-33.png" alt="MiABC Logo" className="privacy-logo" />
          <h1 className="privacy-title">{t("privacyPolicy")}</h1>
        </div>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2 className="section-title">{t("introduction")}</h2>
            <p className="section-text">{t("welcomeText")}</p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">{t("informationWeCollect")}</h2>
            
            <div className="subsection">
              <h3 className="subsection-title">1. {t("personalInformation")}</h3>
              <p className="section-text">{t("personalInfoText")}</p>
              <ul className="privacy-list">
                <li>{t("contactInfo")}</li>
                <li>{t("childInfo")}</li>
              </ul>
            </div>

            <div className="subsection">
              <h3 className="subsection-title">2. {t("nonPersonalInformation")}</h3>
              <p className="section-text">{t("nonPersonalInfoText")}</p>
              <ul className="privacy-list">
                <li>{t("deviceInfo")}</li>
                <li>{t("usageData")}</li>
              </ul>
            </div>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">{t("howWeUseInfo")}</h2>

            <div className="subsection">
              <h3 className="subsection-title">1. {t("personalInformation")}</h3>
              <p className="section-text">{t("personalInfoUsage")}</p>
              <ul className="privacy-list">
                <li>{t("accountManagement")}</li>
                <li>{t("personalization")}</li>
                <li>{t("communication")}</li>
              </ul>
            </div>

            <div className="subsection">
              <h3 className="subsection-title">2. {t("nonPersonalInformation")}</h3>
              <p className="section-text">{t("nonPersonalInfoUsage")}</p>
              <ul className="privacy-list">
                <li>{t("usageAnalysis")}</li>
                <li>{t("technicalSupport")}</li>
                <li>{t("researchDevelopment")}</li>
              </ul>
            </div>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">{t("dataSecurity")}</h2>
            <p className="section-text">{t("dataSecurityText")}</p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">{t("parentalConsent")}</h2>
            <p className="section-text">{t("parentalConsentText")}</p>
            <ul className="privacy-list">
              <li>{t("emailConsent")}</li>
              <li>{t("paymentConsent")}</li>
              <li>{t("consentForm")}</li>
            </ul>
            <p className="section-text mt-3">{t("parentRights")}</p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">{t("informationSharing")}</h2>
            <p className="section-text">{t("informationSharingText")}</p>
            <ul className="privacy-list">
              <li>{t("serviceProviders")}</li>
              <li>{t("legalRequirements")}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">{t("thirdPartyLinks")}</h2>
            <p className="section-text">{t("thirdPartyLinksText")}</p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">{t("policyChanges")}</h2>
            <p className="section-text">{t("policyChangesText")}</p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">{t("contactUs")}</h2>
            <p className="section-text">{t("contactUsText")}</p>
            <ul className="privacy-list">
              <li>{t("email")}</li>
            </ul>
            <p className="section-text mt-4 highlight-plum"><strong>{t("thankYou")}</strong></p>
          </section>
        </div>
      </div>

      <style>{`
        .privacy-page-container {
          padding: 120px 20px 60px;
          display: flex;
          justify-content: center;
          width: 100%;
        }
        .privacy-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 40px;
          box-shadow: 0 30px 60px rgba(0,0,0,0.1);
          border: 1px solid rgba(255, 255, 255, 0.8);
          width: 100%;
          max-width: 900px;
          overflow: hidden;
          animation: fadeIn 0.8s ease-out;
        }
        .privacy-header {
          padding: 4rem 3rem 2rem;
          background: linear-gradient(to bottom, rgba(235, 33, 120, 0.05), transparent);
          text-align: center;
          position: relative;
        }
        .btn-back {
          position: absolute;
          top: 2rem;
          left: 3rem;
          color: var(--plum-bg);
          text-decoration: none;
          font-weight: 700;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 8px;
          transition: all 0.3s ease;
          padding: 10px 20px;
          border-radius: 20px;
          background: white;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }
        .btn-back:hover {
          color: var(--pink-bright);
          transform: translateX(-5px);
          box-shadow: 0 6px 15px rgba(0,0,0,0.1);
        }
        .privacy-logo {
          height: 60px;
          margin-bottom: 2rem;
        }
        .privacy-title {
          font-size: 2.5rem;
          font-weight: 800;
          color: var(--plum-bg);
          margin-bottom: 0;
        }
        .privacy-content {
          padding: 2rem 4rem 4rem;
        }
        .privacy-section {
          margin-bottom: 3.5rem;
        }
        .section-title {
          font-size: 1.6rem;
          font-weight: 700;
          color: var(--plum-bg);
          border-bottom: 3px solid var(--pastel-pink);
          padding-bottom: 10px;
          margin-bottom: 1.5rem;
          display: inline-block;
        }
        .subsection {
          margin-bottom: 2rem;
          padding-left: 1.5rem;
          border-left: 2px solid var(--pastel-blue);
        }
        .subsection-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: var(--pink-bright);
          margin-bottom: 1rem;
        }
        .section-text {
          font-size: 1.05rem;
          line-height: 1.7;
          color: var(--text-gray);
          margin-bottom: 1rem;
        }
        .privacy-list {
          list-style: none;
          padding: 0;
          margin: 1rem 0;
        }
        .privacy-list li {
          position: relative;
          padding-left: 1.5rem;
          margin-bottom: 0.8rem;
          color: var(--text-gray);
          font-weight: 500;
        }
        .privacy-list li::before {
          content: "•";
          color: var(--orange-bright);
          font-weight: bold;
          position: absolute;
          left: 0;
          font-size: 1.2rem;
        }
        .highlight-plum {
          color: var(--plum-bg);
        }
        @media (max-width: 768px) {
          .privacy-header { padding: 5rem 1.5rem 2rem; }
          .btn-back { top: 1.5rem; left: 1.5rem; }
          .privacy-content { padding: 2rem 1.5rem; }
          .privacy-title { font-size: 2rem; }
          .section-title { font-size: 1.4rem; }
        }
      `}</style>
    </div>
  )
}

export default Terms
